import { render } from "./gfairmodule.vue?vue&type=template&id=d38b70b0&scoped=true"
import script from "./gfairmodule.vue?vue&type=script&lang=js"
export * from "./gfairmodule.vue?vue&type=script&lang=js"

import "./gfairmodule.vue?vue&type=style&index=0&id=d38b70b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38b70b0"]])

export default __exports__